<div id="toxicologyExpectedResults" style="padding: 8px"  [style.display]="hasResults ? 'block' : 'none'">
    <div style="text-align: center; background-color: rgba(16,172,95,0.68); height: 24px" [ngStyle.xs]="{height: '40px'}">
        <h5 style="height: 24px">Consistent Result - Reported Medication Detected</h5>
    </div>
    <dx-tree-list
        #toxiExpectedTree
        [dataSource]="dataSource"
        dataStructure="tree"
        itemsExpr="tests"
        keyExpr="treeId"
        height='100%'
        [showRowLines]="true"
        [showBorders]="true"
        [hoverStateEnabled]="true"
        [highlightChanges]="true"
        [columnAutoWidth]="true"
        [allowColumnResizing]="true"
        [columnHidingEnabled]="isPhoneOrTablet">
        <dxi-column caption="Reported Medications" dataField="medicationName" allowFiltering="true" [hidingPriority]="isPhoneOrTablet ? 3 : -1"></dxi-column>
        <dxi-column caption="Anticipated Positives" dataField="name" allowFiltering="false" [hidingPriority]="isPhoneOrTablet ? 0 : -1"></dxi-column>
        <dxi-column dataField="result" caption="Amount Detected" allowFiltering="false" [hidingPriority]="isPhoneOrTablet ? 2 : -1"></dxi-column>
        <dxi-column dataField="detectionWindow" caption="Typical Detection Window" allowFiltering="false" [hidingPriority]="isPhoneOrTablet ? 1 : -1"></dxi-column>
    </dx-tree-list>
</div>
